export default "__VITE_ASSET__d1424673__"